import { Grid } from '@mui/material';
import React from 'react';
import Page404 from '../../assets/images/notfound.jpg'

const NotFound = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
            <img style={{width:"100%"}} src={Page404} alt="" />
            </Grid>
        </Grid>
    );
};

export default NotFound;